import { useMutation, useQueryClient } from 'react-query';
import { ITcoLocations } from 'types';
import { tcoLocationRequest, queryKeys } from 'utils';

export const useDeleteTcoLocations = (estimateId: string) => {
  const queryClient = useQueryClient();
  const queryKey = queryKeys({ estimateId: estimateId }).filter.tcoLocations;

  const {
    mutate: deleteTcoLocation,
    isLoading: deleteTcoLocationLoading,
    isSuccess: deleteTcoLocationSuccess,
    isError: deleteTcoLocationError,
  } = useMutation(
    (tcoLocation: ITcoLocations) =>
      tcoLocationRequest({
        endpoint: `tco-locations/${tcoLocation.id}`,
        method: 'DELETE',
      }),
    {
      onMutate: async (deletedTcoLocation: ITcoLocations) => {
        await queryClient.cancelQueries(queryKey);

        const previousLocations =
          queryClient.getQueryData<ITcoLocations[]>(queryKey) || [];

        const newLocations = previousLocations.filter(
          (s) => s.id !== deletedTcoLocation.id
        );

        queryClient.setQueryData(queryKey, newLocations);

        return { previousLocations };
      },
      onError: async (err, _, context) => {
        console.log(err);
        await queryClient.cancelQueries(queryKey);
        queryClient.setQueryData(queryKey, context?.previousLocations);
      },
      onSettled: () => {
        queryClient.invalidateQueries(queryKey);
      },
    }
  );

  return {
    deleteTcoLocation,
    deleteTcoLocationLoading,
    deleteTcoLocationSuccess,
    deleteTcoLocationError,
  };
};
